<template>
  <div class="width-100-pr">
    <div
      class="node-activation-date"
      v-if="this.element.fecha_inicio"
    >
      <DatePicker
        :placeholder="this.$t('mEditionMapPathTreeNodeActionsActivationImmediate.messages.notActivated')"
        input-class="a-input-datepicker-borderless width-80-px"
        calendar-button="false"
        calendar-button-icon="far fa-calendar-alt"
        data-container="body"
        :value="diaCalendario"
        :format="customFormat"
        :disabled-dates="disabledDates"
        @input="updateValue"
      >
      </DatePicker>
    </div>
    <input
      v-model="diaNodo"
      class="a-input-side a-input-primary text-align-center width-25-px"
      :min="minDia"
      :max="maxDia"
      name="dia"
      type="number"
      @keyup="changeDay"
    />
    <span
      class="node-activation-date"
      v-if="!this.element.fecha_inicio"
    >
      {{ activationDate }}
    </span>
  </div>
</template>

<script>

export default {
  name: 'MoleculeEditionMapPathTreeNodeActionsActivationImmediate',

  props: {
    contenido: Object,
    element: Object,

    info: {
      type: Object,
      default: null
    },

    nodo: Object,

    parent: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      diaNodo: '',

      diaCalendario: '',

      disabledDates: {
        to: null,
        from: null
      }
    }
  },

  computed: {
    activationDate () {
      if (this.diaNodo === '') {
        return this.$t('mEditionMapPathTreeNodeActionsActivationImmediate.messages.notActivated')
      } else if (this.diaNodo === 0) {
        return this.element.fecha_inicio
          ? this.$moment.parseZone(this.element.fecha_inicio).format('DD-MM-YYYY')
          : this.$t('mEditionMapPathTreeNodeActionsActivationImmediate.messages.inmediate')
      } else {
        return this.element.fecha_inicio
          ? this.$moment.parseZone(this.element.fecha_inicio).add(parseInt(this.diaNodo), 'days').format('DD-MM-YYYY') > this.$moment.parseZone(this.element.fecha_finalizacion).format('DD-MM-YYYY') ? this.$moment.parseZone(this.element.fecha_finalizacion).format('DD-MM-YYYY') : this.$moment.parseZone(this.element.fecha_inicio).add(parseInt(this.diaNodo), 'days').format('DD-MM-YYYY')
          : this.$t('mEditionMapPathTreeNodeActionsActivationImmediate.messages.daysAfter')
      }
    },

    minDia () {
      return this.parent !== null ? this.searchDay(this.parent.id) : 0
    },

    maxDia () {
      return this.element.fecha_finalizacion ? (this.$moment(this.element.fecha_finalizacion).toDate() - this.$moment(this.element.fecha_inicio).toDate()) / (1000 * 60 * 60 * 24) : 1000
    }
  },

  watch: {
    'info.nodosActivos': {
      deep: true,

      handler () {
        let dia = this.searchDay(this.nodo.id)
        this.diaNodo = dia === -1 ? '' : dia
        this.diaCalendario = dia === -1 ? null : this.$moment(this.$utils.formatISODateTime(this.element.fecha_inicio)).add(this.diaNodo, 'days').toDate()
      }
    },

    minDia () {
      if (this.minDia > 0 && this.minDia > this.diaNodo) {
        this.diaNodo = this.minDia
        this.$emit('emitAction', { nodo: this.nodo.id, dia: this.minDia })
      }
    },

    maxDia () {
      if (this.$moment(this.element.fecha_inicio).add(this.diaNodo, 'days').toDate() < this.$moment(this.element.fecha_finalizacion).toDate()) {
        this.diaNodo = this.maxDia
        this.$emit('emitAction', { nodo: this.nodo.id, dia: this.maxDia })
      }
    }
  },

  created () {
    let dia = this.searchDay(this.nodo.id)
    this.diaNodo = dia === -1 ? '' : dia
    this.diaCalendario = dia === -1
      ? null
      : this.element.fecha_inicio
        ? this.$moment(this.$utils.formatISODateTime(this.element.fecha_inicio)).add(this.diaNodo, 'days').toDate()
        : null
    this.disabledDates.to = this.element.fecha_inicio ? this.$moment(this.$utils.formatISODateTime(this.element.fecha_inicio)).toDate() : null
    this.disabledDates.from = this.element.fecha_finalizacion ? this.$moment(this.$utils.formatISODateTime(this.element.fecha_finalizacion)).toDate() : null
  },

  methods: {
    changeDay (event) {
      this.diaCalendario = this.element.fecha_finalizacion ? this.$moment(this.$utils.formatISODateTime(this.element.fecha_inicio)).add(this.diaNodo, 'days').toDate() : null
      this.$emit('emitAction', { nodo: this.nodo.id, dia: event.target.value })
    },

    searchDay (idNodo) {
      return parseInt(this.info.nodosActivos.nodos.find(anodo => anodo.nodo === idNodo).dia)
    },

    customFormat (date) {
      return this.$moment(date).format('DD-MM-YYYY')
    },

    updateValue (date) {
      this.diaNodo = (this.$moment(date).toDate() - this.$moment(this.element.fecha_inicio).toDate()) / (1000 * 60 * 60 * 24)
      this.$emit('emitAction', { nodo: this.nodo.id, dia: this.diaNodo })
    }
  }
}
</script>
